import React, { useContext } from 'react';
import { FaNotesMedical } from 'react-icons/fa';
import HeaderReusable from '../../Global/HeaderContent';
import { SettingGeneralContext, SettingGeneralProvider } from '../../../context/settingGeneralContext';



export default function Header({
  isTabletOrMobile,
  query,
  setQuery,
  searchData,
  viewModalAdd,
  buttonRefresh
}) {
  return (
    <SettingGeneralProvider>
      <HeaderContent
        isTabletOrMobile={isTabletOrMobile}
        query={query}
        setQuery={setQuery}
        searchData={searchData}
        viewModalAdd={viewModalAdd}
        buttonRefresh={buttonRefresh}
      />
    </SettingGeneralProvider>
  )
}


function HeaderContent({
  isTabletOrMobile,
  query,
  setQuery,
  searchData,
  viewModalAdd,
  buttonRefresh
}) {
  return (
    <>
      <HeaderReusable
        title="Treatment Plan Pasien"
        icon={FaNotesMedical}
        isTabletOrMobile={false}
        query={query}
        setQuery={setQuery}
        searchData={searchData}
        onAdd={viewModalAdd}
        onRefresh={buttonRefresh}
        showAddButton={true}
        showRefreshButton={true}
      />
    </>
  )
}


